import React from 'react'
import { StepContainer, TitleSection, InfoSection, HeaderWrapper, ContentSection } from './style'
import { Message } from 'semantic-ui-react'

interface StepLayoutProps {
  infoText: string
  children: React.ReactNode
}

const SilageStepLayout: React.FC<StepLayoutProps> = ({ infoText, children }) => {
  return (
    <StepContainer>
      <HeaderWrapper>
        <Message info style={{
          borderRadius: '10px',
          marginLeft: 'auto',
          marginRight: 'auto',
          width: 'fit-content',
          textAlign: 'center'
        }}>
          <Message.Content>
            <div dangerouslySetInnerHTML={{ __html: infoText }} />
          </Message.Content>
        </Message>
      </HeaderWrapper>

      <ContentSection>
        {children}
      </ContentSection>
    </StepContainer>
  )
}

export default SilageStepLayout